export const borderRadius = '8px';
export const palettePrimaryDarker = '#31635a'; //darker green
export const palettePrimaryDark = '#3e7c71'; // dark green
export const palettePrimaryMain = '#4a9789';
export const palettePrimaryLight = '#57af9f'; // light green
export const palettePrimaryLighter = '#64c9b6'; // lighter green
export const palettePrimaryContrast = '#fafbfc'; // text color that contrasts well with green

export const paletteNeutralDarker = '#6E6E6E';
export const paletteNeutralDark = '#6E6E6E';
export const paletteNeutralMain = '#6E6E6E';
export const paletteNeutralLight = '#6E6E6E';
export const paletteNeutralLighter = '#6E6E6E';
export const paletteNeutralContrast = 'white';

export const paletteErrorDarker = '#8c071d';
export const paletteErrorDark = '#b00925';
export const paletteErrorMain = '#de092d';
export const paletteErrorLight = '#db4861';
export const paletteErrorLighter = '#d66578';
export const paletteErrorContrast = 'white';

export const palettePaperDarker = '#eee';
export const palettePaperDark = '#d6d6d6';
export const palettePaperMain = '#f0f0f0';
export const palettePaperLight = '#f3f3f3';
export const palettePaperLighter = '#fff';
export const palettePaperContrast = '#222';

// Custom
export const paletteHighlight = '#ffff006e';
